import { useQuery } from "@tanstack/react-query";
import { useAppRouter } from "~/hooks/use-app-router";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import { GetCommentsByFileIdQuery } from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetCommentsByFileId($fileId: ObjectID!) {
		getCommentsByFileId(fileId: $fileId) {
			_id
			createdAt
			updatedAt
			user
			text
			attachments {
				name
				size
				url
				extension
			}
			comment

			_user {
				firstName
				lastName
				avatar
			}
		}
	}
`;

export type GetCommentsByFileIdResults =
	GetCommentsByFileIdQuery["getCommentsByFileId"];

export const getCommentsByFileIdQueryKey = (fileId: string) => [
	"getCommentsByFileId",
	fileId,
];

export const useGetCommentsByFileId = (fileId?: string, enabled?: boolean) => {
	return useQuery({
		enabled: enabled ?? !!fileId,
		queryKey: getCommentsByFileIdQueryKey(fileId!),
		queryFn: async () =>
			apiGqlClient
				.request(graphql(query), { fileId: fileId! })
				.then((res) => res.getCommentsByFileId),
	});
};

export const useGetCommentsByFileIdCache = (fileId?: string) => {
	return useGetCommentsByFileId(fileId, false);
};

export const useGetCurrentFileComments = () => {
	const { appQuery } = useAppRouter();
	return useGetCommentsByFileId(appQuery.fileId);
};

export const useGetCurrentFileCommentsCache = () => {
	const { appQuery } = useAppRouter();
	return useGetCommentsByFileIdCache(appQuery.fileId);
};
